import React from "react";
import { motion } from "framer-motion";

import "../Styles/Award.css";

import mashable from "../Assets/award1.png";
import techradar from "../Assets/award2.png";
import smashing from "../Assets/award3.png";
import awardGif from "../Assets/award gif.gif"; // <-- Add your GIF here

const awards = [
  { title: "Digital Marketing", subtitle: "Winner", year: "2022" },
  { title: "Ads Promotion", subtitle: "Winner", year: "2023" },
  { title: "Web Development", subtitle: "Winner", year: "2024" },
];

const logos = [mashable, techradar, smashing];

// Fade-up animation variants
const fadeUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const Award = () => {
  return (
    <motion.section
      className="award-section" id="awards"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={fadeUp}
    >
      <motion.div
        className="award-left"
        variants={fadeUp}
      >
        <h2>Best Digital Marketing Company in Tamilnadu.</h2>
        <p>
          Discover why DD Digital Construction has been awarded the Best Digital
          Marketing Agency in Tamilnadu for 2023 and 2024. With proven expertise
          in SEO, social media marketing, and tailored digital strategies, we
          help businesses grow and achieve measurable results. Partner with the
          trusted leader in digital marketing services today!
        </p>

        {/* GIF below the paragraph */}
        <div className="award-left-gif">
          <img src={awardGif} alt="Award GIF" />
        </div>
      </motion.div>

      <motion.div
        className="award-right"
        variants={fadeUp}
      >
        <div className="award-box">
          <h3>
            <span className="highlight">3</span> Awards
          </h3>
          <ul>
            {awards.map((item, index) => (
              <li key={index}>
                <div className="award-icon">🏆</div>
                <div>
                  <h4>{item.title}</h4>
                  <p>
                    {item.subtitle} <br />
                    <span>{item.year}</span>
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="logo-bubbles">
          {logos.map((logo, index) => (
            <div className="bubble" key={index}>
              <img src={logo} alt="logo" />
            </div>
          ))}
        </div>
      </motion.div>
    </motion.section>
  );
};

export default Award;
